module.exports = __webpack_public_path__ + "img/service-icon-1.b231e4af.png";